import _ from 'underscore';

import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import filterNumbers from 'notebook/tables/excess/util/filterNumbers';
import {coerceToPrimitive} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export default {
  name: 'MIN',
  category: FunctionCategory.STATS,
  shortDescription: 'Minimum value in a numeric dataset.',
  description: 'Returns the minimum value in a numeric dataset.',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'The first value or range to consider when calculating the minimum value.',
      coerce: (typedValue: TypedValue, languageTag?: string | null) =>
        coerceToPrimitive(typedValue, {
          shouldCoerceStringToNumber: true,
          shouldCoerceDateToNumber: true,
          languageTag,
        }),
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription:
    'Additional values or ranges to consider when calculating the minimum value.',

  eval: (...values): number => {
    const numberValues = filterNumbers(values);
    if (numberValues.length === 0) {
      return 0;
    }
    return _.min(numberValues);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
